import axios from "@/services/axios";
import { getPaginationValues } from "@/utils/pagination-helper";
import { computed, reactive } from "vue";

const state = reactive({
  selectedResearchInfrastructure: {} as any,
  group: [],
});

export default function ResearchInfrastructureRepositoryAPI() {
  async function load(): Promise<void> {
    const data = await axios
      .get(`api/v1/ResearchInfrastructure?PageNumber=0&PageSize=250`)
      .then((response: any) => {
        return response.data;
      });
    state.group = data;
  }

  const loadItems = (data: any): void => {
    axios
      .get(
        `api/v1/ResearchInfrastructure?PageNumber=${data.lazyParams.page}&PageSize=${data.lazyParams.rows}&Keyword=${data.keywords}`,
        {
          showAll: true,
        } as any
      )
      .then((response: any) => {
        data.infrastructureGroup = response.data;
        data.lazyParams = getPaginationValues(response.headers);
        data.dataLoading = false;
      })
      .catch(() => (data.dataLoading = false));
  };

  const loadItem = (data: any, id: string): void => {
    axios
      .get(`api/v1/ResearchInfrastructure/${id}/detail`)
      .then((response: any) => {
        data.infrastructureGroup.push(response.data);
        data.dataLoading = false;
      })
      .catch(() => (data.dataLoading = false));
  };

  const setResearchInfrastructure = (selected: any) => {
    state.selectedResearchInfrastructure = selected;
  };

  return {
    setResearchInfrastructure,
    getSelectedResearchInfrastructure: computed(
      () => state.selectedResearchInfrastructure
    ),
    loadResearchInfrastructureGroup: load,
    researchInfrastructureState: computed(() => state),
    loadItems,
    loadItem,
  };
}
